import React from 'react';
import { SvgType } from '@rocheglobal/component-library/src/services';
import { StoryblokLinkNode } from '../../services/navigation/types';

interface BreadcrumbProps {
  list: StoryblokLinkNode[]
}

interface BreadcrumbItemProps {
  link: StoryblokLinkNode;
  icon?: SvgType;
}

const filterBreadcrumbs = (
  list: StoryblokLinkNode[],
) => list?.filter((
  link: StoryblokLinkNode,
  index: number,
  breadcrumbs: StoryblokLinkNode[],
) => {
  const { real_path: url } = link;
  const { real_path: nextUrl } = breadcrumbs[index + 1] || {};

  return (
    `${url}/` !== nextUrl
    && index < breadcrumbs.length - 1
  );
});

const BreadcrumbItem = ({ link, icon }: BreadcrumbItemProps) => {
  const { real_path: url, name } = link;

  return (
    <roche-generic-link
      type="breadcrumbs"
      target="_self"
      url={url}
      text={name}
      icon={icon}
      size="medium"
    >
    </roche-generic-link>
  );
};

export const RocheBreadcrumbs = ({ list }: BreadcrumbProps) => {
  const breadcrumbs = filterBreadcrumbs(list);

  return <roche-grid no-padding data-breadcrumbs>
    <roche-breadcrumbs>
      <ol>
        {breadcrumbs?.map((link: StoryblokLinkNode, index) => (
          <li key={index}>
            <BreadcrumbItem link={link} icon={index <= 0 ? undefined : 'chevron-right'}/>
          </li>
        ))}
      </ol>
    </roche-breadcrumbs>
  </roche-grid>;
};
